import doRequest from "./index";
import { baseUrl } from "../common/Constant";

const UserService = {
  // a function to call login api
  login: (username, password) => {
    const body = new URLSearchParams({
      user: username,
      password: password,
    }).toString();
    return doRequest("post", `${baseUrl}dataout2/loginv2.php`, body, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  },
};

export default UserService;
